import { render, staticRenderFns } from "./ForgotClientPassword.vue?vue&type=template&id=d6549d0c&scoped=true&"
import script from "./ForgotClientPassword.vue?vue&type=script&lang=js&"
export * from "./ForgotClientPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6549d0c",
  null
  
)

export default component.exports